<template>
	<vue-typeahead-bootstrap
		size="sm"
		:value="value"
		:data="fonts"
		:serializer="item => item.family"
		placeholder="Search fonts..."
		disable-sort
		autocomplete="off"
		@input="onInput"
	/>
</template>

<script>
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap';
import { getGoogleFonts } from '@/googleFonts';

// Emits the chosen family (or '' for the default font) — never a half-typed name, so nothing downstream tries to load it.
export default {
	components: { VueTypeaheadBootstrap },
	props: {
		value: { type: String, default: '' },
	},
	data() { return { fonts: [] }},
	computed: {
		families() { return new Set(this.fonts.map(f => f.family)); },
	},
	async mounted() {
		try {
			this.fonts = await getGoogleFonts(this.$api);
		} catch(e) {
			console.error('Could not load the Google Fonts list', e);
		}
	},
	methods: {
		onInput(text) {
			if(!text || this.families.has(text)) this.$emit('input', text);
		},
	},
};
</script>
